{
  "nav": {
    "home": "Accueil",
    "pick": "Pronostics",
    "leaderboard": "Classement",
    "profile": "Profil",
    "leagues": "Ligues",
    "active_league": "Ligue Active"
  },
  "common": {
    "error_data": "Erreur lors du chargement des données.",
    "stage": "Étape",
    "go": "ALLER",
    "back": "← Retour",
    "one_day_race": "Course d'un jour",
    "tomorrow": "Demain",
    "in_days_one": "Demain",
    "in_days_many": "Dans {{count}} jours",
    "in_days_other": "Dans {{count}} jours",
    "at_hours": "À {{hours}} heures",
    "loading": "Chargement...",
    "confirm": "CONFIRMER",
    "logout": "DÉCONNEXION",
    "in_days": "Dans {{count}} jours",
    "error_generic": "Une erreur s'est produite.",
    "optional": "optionnel",
    "tu": "TOI",
    "error_title": "Erreur",
    "send": "Envoyer",
    "retry": "Réessayer",
    "load_error_title": "Impossible de charger les données",
    "load_error_sub": "Vérifie ta connexion et réessaie.",
    "stale_data": "Données non à jour : affichage des données enregistrées."
  },
  "home": {
    "participants": "participants",
    "section_results": "Derniers résultats",
    "section_upcoming": "Prochaines courses",
    "social": "Suis-nous sur les réseaux sociaux",
    "onboarding_next": "Suivant →",
    "onboarding_start": "Commence à jouer →",
    "onboarding_rules": "Lire le règlement",
    "section_picks": "Pronostics à faire",
    "no_races": "Aucune course à pronostiquer pour le moment",
    "other_picks_one": "un autre pronostic à faire →",
    "other_picks_many": "{{count}} autres pronostics à faire →",
    "other_picks_other": "{{count}} autres pronostics à faire →",
    "stage_results": "Classement",
    "tab_stage": "ÉTAPE",
    "tab_gc": "GÉNÉRAL",
    "no_data": "Aucune donnée disponible",
    "onboarding_step1_title": "Bienvenue sur Virtua Cycling !",
    "onboarding_step1_body": "Le jeu fantasy du cyclisme professionnel.",
    "onboarding_step2_title": "Comment ça marche",
    "onboarding_item1": "Choisis tes coureurs — Avant chaque étape, sélectionne les coureurs sur lesquels tu paries. Tu as jusqu'au départ.",
    "onboarding_item2": "Gagne des points — Tes coureurs marquent des points selon leur classement réel à l'étape et au classement général.",
    "onboarding_item3": "Crée ta ligue — Affronte les autres participants étape après étape et grimpe au classement général.",
    "onboarding_step3_title": "Tu es prêt !",
    "onboarding_step3_body": "Tu es dans la Virtua Cycling League, la ligue générale où tout le monde joue. Lis le règlement complet pour ne rien manquer.",
    "kofi_cta": "Tu aimes l'application ? Offre-nous une bière !",
    "jersey_gc": "Maillot leader GC",
    "jersey_pt": "Maillot à points",
    "jersey_gm": "Maillot GPM",
    "greeting": "Salut, {{name}}",
    "status_ready": "Choix confirmés pour la prochaine étape",
    "status_todo": "Tu n'as pas encore fait tes choix",
    "retry": "Réessayer"
  },
  "pick": {
    "live_label": "EN DIRECT",
    "pick_done": "Pronostics déjà effectués — tu peux encore les modifier",
    "no_pick_stage": "Aucun pronostic trouvé pour cette étape.",
    "error_load": "Erreur lors du chargement des courses.",
    "loading": "Chargement...",
    "title": "Pronostics",
    "no_races_title": "Aucune course disponible",
    "no_races_sub": "Aucune course n'est prévue pour le moment. Reviens bientôt !",
    "banned_title": "Retrait de la course",
    "banned_stages_one": "Tu as manqué 1 étape",
    "banned_stages_many": "Tu as manqué {{count}} étapes",
    "banned_stages_other": "Tu as manqué {{count}} étapes",
    "banned_detail": "Tu peux suivre les résultats et les pronostics des autres, mais tu ne peux pas participer à cette édition.",
    "banned_message": "À la prochaine !",
    "stage_finished": "Étape terminée. Voici les pronostics effectués.",
    "live_alert": "Course en cours — équipes alignées",
    "startlist_btn": "Liste de départ",
    "startlist_title": "Liste de départ",
    "startlist_search": "Chercher dossard ou nom",
    "startlist_dnf": "Abandon",
    "startlist_empty": "Liste de départ pas encore disponible",
    "tab_insert": "Saisie",
    "tab_summary": "Récapitulatif",
    "start_list_title": "Liste de départ pas encore prête",
    "start_list_sub": "La liste des partants sera publiée prochainement. Reviens vérifier plus tard.",
    "need_more_one": "Sélectionne encore {{count}} coureur.",
    "need_more_many": "Sélectionne encore {{count}} coureurs.",
    "need_more_other": "Sélectionne encore {{count}} coureurs.",
    "error_save": "Erreur lors de l'enregistrement.",
    "loading_riders": "Chargement des coureurs...",
    "draft_restored": "Brouillon restauré",
    "draft_count_one": "1 coureur enregistré localement",
    "draft_count_many": "{{count}} coureurs enregistrés localement",
    "draft_count_other": "{{count}} coureurs enregistrés localement",
    "draft_cancel": "Annuler",
    "select_n_one": "Sélectionne {{count}} coureur",
    "select_n_many": "Sélectionne {{count}} coureurs",
    "select_n_other": "Sélectionne {{count}} coureurs",
    "add_rider": "+ Ajouter un coureur ({{current}}/{{limit}})",
    "edit_selection": "Modifier la sélection",
    "apply_all": "Appliquer le choix à toutes mes ligues",
    "saved_for": "Enregistré pour : {{leagues}}",
    "flip_used": "Flip — utilisé",
    "flip_available": "Flip — disponible",
    "flip_remove": "Retirer",
    "flip_abbinato": "{{rider}} associé au slot {{slot}}",
    "flip_confirmed": "Le flip a été déclaré pour cette étape. Le meilleur sera choisi lors du calcul des points.",
    "flip_slot_label": "Associer le flip à quel slot ?",
    "flip_confirm_btn": "Confirmer le flip",
    "saving": "Enregistrement...",
    "confirm_pick": "CONFIRMER LE PRONOSTIC {{current}}/{{limit}}",
    "select_riders": "Sélectionner des coureurs",
    "search_rider": "Rechercher un coureur...",
    "no_rider_found": "Aucun coureur trouvé",
    "compare_users": "Comparer les utilisateurs",
    "confirm": "Confirmer",
    "no_pick_found": "Aucun pronostic trouvé.",
    "toast_multi_one": "Pronostics enregistrés sur 1 ligue",
    "toast_multi_many": "Pronostics enregistrés sur {{count}} ligues",
    "toast_multi_other": "Pronostics enregistrés sur {{count}} ligues",
    "toast_single": "Pronostics enregistrés !",
    "compare_with": "Comparer avec {{names}}",
    "compare_default": "Comparer avec d'autres utilisateurs (max {{max}})",
    "tap_to_change": "• touche pour changer",
    "you": "(TOI)",
    "matrix_hint": "Touche un coureur pour voir qui l'a choisi",
    "user_col": "Utilisateur",
    "scout_title": "Rapport de scoutisme",
    "scout_top_rider": "Coureur le plus choisi",
    "scout_distribution": "Répartition par slot",
    "scout_variety": "Variété de la ligue",
    "scout_distinct": "Coureurs distincts choisis",
    "scout_identical": "Formations identiques",
    "scout_no_picks": "Fais tes pronostics pour voir combien de joueurs ont la même formation que toi",
    "loading_lineups": "Chargement des formations...",
    "collapse_all": "TOUT FERMER",
    "expand_all": "TOUT DÉPLIER",
    "no_races": "Aucune course disponible pour le moment.",
    "add_rider_one": "+ Ajouter un coureur ({{current}}/{{limit}})",
    "duplicate_rider": "{{name}} a déjà été aligné lors d'une étape précédente !",
    "draft_count": "Tu as {{count}} coureur(s) enregistré(s) localement",
    "toast_multi": "Pronostics enregistrés sur {{count}} ligues",
    "scout_chosen_by": "Choisi par : {{names}}",
    "scout_chosen_by_others": "Choisi par : {{names}} et {{count}} autres",
    "scout_sharing": "Partage en cours...",
    "scout_share_btn": "Partager le rapport de scoutisme",
    "scout_outsider": "Outsider",
    "scout_contrarian": "Choix le plus audacieux",
    "scout_slot": "SLOT {{n}}",
    "scout_players": "{{count}} joueurs",
    "draft_unsaved_banner": "Pronostic non confirmé — appuie sur Confirmer pour l'enregistrer",
    "draft_unsaved_title": "Pronostic non confirmé",
    "draft_unsaved_body": "Tu as une sélection non enregistrée. Veux-tu confirmer le pronostic avant de sortir ?",
    "draft_exit": "Sortir sans enregistrer",
    "draft_confirm_now": "Rester et confirmer",
    "share_all": "Tous",
    "current_league": "Ligue actuelle",
    "duplicate_rider_reason": "Déjà utilisé : {{name}}",
    "flip_saved": "Flip enregistré !",
    "flip_deleted": "Flip supprimé.",
    "flip_add_rider": "+ Ajouter un coureur flip (optionnel)",
    "riders_count_one": "1 coureur",
    "riders_count_many": "{{count}} coureurs",
    "riders_count_other": "{{count}} coureurs",
    "riders_selected_one": "1 sélectionné",
    "riders_selected_many": "{{count}} sélectionnés",
    "riders_selected_other": "{{count}} sélectionnés",
    "search_user": "Rechercher un utilisateur...",
    "tab_per_tappa": "Par étape",
    "tab_matrice": "Présence des coureurs",
    "matrix_select_riders": "Choisis les coureurs à suivre (max 5)",
    "no_picks_riepilogo": "Aucun pronostic trouvé",
    "no_picks_riepilogo_sub": "Tu n'as pas encore fait de pronostic pour cette course.",
    "scout_avg_pct": "~{{pct}}% en moyenne",
    "scout_no_identical": "Personne d'autre n'a la même formation que toi",
    "scout_identical_count_one": "1 joueur a la même formation que toi",
    "scout_identical_count_many": "{{count}} joueurs ont la même formation que toi",
    "scout_identical_count_other": "{{count}} joueurs ont la même formation que toi",
    "scout_share_dialog": "Rapport de scoutisme — {{name}}",
    "share_hidden": "+ {{count}} AUTRES JOUEURS · OUVRIR L'APPLI",
    "no_picks_tabella": "Aucune formation envoyée",
    "no_picks_tabella_sub": "Les pronostics des autres joueurs apparaîtront ici.",
    "flip_slot_arrow": "→ slot {{slot}}",
    "race_tag_pick": "CHOIX",
    "race_tag_live": "EN DIRECT",
    "race_tag_done": "TERMINÉE",
    "race_switcher_label": "Courses",
    "race_history": "Historique des courses",
    "race_group_next": "À venir",
    "race_group_past": "Passées",
    "close": "Fermer",
    "prev_stage": "Étape précédente",
    "next_stage": "Étape suivante",
    "stage_list_title": "Étapes",
    "matrix_chosen_by": "{{name}} · choisi par {{count}} sur {{total}}",
    "matrix_clear": "Annuler la sélection",
    "matrix_chosen_by_a11y": "choisi par {{count}} joueurs sur {{total}}",
    "matrix_open_player": "Ouvrir les choix de {{name}}",
    "sheet_chosen_by": "{{count}} sur {{total}}",
    "sheet_shared": "Comme toi",
    "sheet_unique": "Choix unique",
    "share_label": "LES CHOIX",
    "share_most_picked": "LE PLUS CHOISI",
    "share_unique_picks": "CHOIX UNIQUES",
    "share_unique_sub": "coureurs choisis par un seul joueur",
    "scout2_title": "Scout",
    "scout2_originality": "TON ORIGINALITÉ",
    "scout2_twin": "TON JUMEAU",
    "scout2_identical": "CHOIX IDENTIQUES",
    "scout2_identical_sub": "joueurs avec le même choix",
    "scout2_bold": "Audacieux",
    "scout2_balanced": "Équilibré",
    "scout2_aligned": "Aligné",
    "scout2_in_common": "{{count}} sur {{total}} en commun",
    "scout2_none": "Aucun",
    "scout2_popularity": "Popularité des coureurs",
    "scout2_tap_hint": "Touche un coureur pour le mettre en évidence dans le tableau",
    "scout2_your_picks": "Tes choix",
    "scout2_also_by": "Aussi choisi par {{names}}",
    "scout2_only_you": "Seulement toi",
    "scout2_outsiders": "Outsiders",
    "finished_banner": "Course terminée · tu es {{pos}}e avec {{pts}} pts",
    "finished_banner_nopos": "Course terminée",
    "finished_cta": "Classement",
    "scout2_like_you": "Qui a joué comme toi",
    "scout2_twins_card": "TES JUMEAUX",
    "scout2_same_as_you": "{{count}} avec ton même choix",
    "scout2_same_picks": "Même choix",
    "scout2_group_count": "{{count}} joueurs",
    "scout2_no_common": "Aucun coureur en commun avec",
    "scout2_other_identical": "Autres choix identiques",
    "result_title": "Comment ça s'est passé",
    "result_total": "Tu as marqué {{pts}} pts",
    "result_pick_line": "prévu {{slot}}e · arrivé {{rank}}e",
    "result_dnf": "non classé",
    "result_best": "Ton meilleur",
    "result_worst": "Ce qui t'a coûté le plus",
    "result_malus": "Vainqueur non choisi",
    "result_bonus_top10": "Tous dans le top 10",
    "result_bonus_top15": "Tous dans le top 15",
    "result_winner": "Le vainqueur",
    "result_winner_owners": "choisi par {{count}} sur {{total}}",
    "result_nobody": "Personne ne l'avait",
    "result_difference": "A fait la différence",
    "result_difference_sub": "ceux qui l'avaient ont marqué {{delta}} pts en moyenne par rapport aux autres",
    "result_flop": "A coulé beaucoup de monde",
    "result_flop_sub": "ceux qui l'avaient ont marqué {{delta}} pts en moyenne par rapport aux autres",
    "rules_title": "Règles en bref",
    "rules_1": "Un coureur par étape, trois dans les contre-la-montre.",
    "rules_2": "Un coureur ne peut pas être utilisé deux fois dans la même course.",
    "rules_3": "Si tu manques ne serait-ce qu'une étape, tu es éliminé de la course : tu peux suivre, mais pas jouer.",
    "rules_flip": "Flip : une seule fois par course, tu indiques un coureur de réserve ; il compte à la place du titulaire seulement s'il arrive mieux.",
    "profile_flat": "Plaine",
    "profile_hilly": "Vallonnée",
    "profile_mountain": "Montagne",
    "profile_itt": "Contre-la-montre",
    "profile_ttt": "Contre-la-montre par équipes",
    "view_by_rider": "Par coureur",
    "view_by_player": "Par joueur",
    "tour_summary": "{{riders}} coureurs choisis par {{players}} joueurs",
    "your_pick": "Ton choix",
    "tour_your_result": "Ton résultat",
    "tour_stage_winner": "Vainqueur de l'étape",
    "stage_finished_banner": "Étape terminée · tu es {{pos}}e de l'étape ({{gap}})",
    "share_label_stage": "LES CHOIX DE L'ÉTAPE",
    "share_distinct_riders": "COUREURS DIFFÉRENTS",
    "scout_t_position": "TU ES DANS",
    "scout_t_break": "L'ÉCHAPPÉE",
    "scout_t_small": "UN PETIT GROUPE",
    "scout_t_group": "LE PELOTON",
    "scout_t_with": "avec {{count}} joueurs",
    "scout_t_alone": "seulement toi",
    "scout_t_leader": "LE LEADER A CHOISI",
    "scout_t_jerseys": "Les maillots : ce qu'ils ont choisi",
    "scout_t_breakaway": "Dans l'échappée",
    "closes_at": "Ferme {{when}}",
    "closes_in": "Ferme dans {{time}}",
    "profile_title": "Profil altimétrique",
    "profile_climbs": "Ascensions",
    "profile_coppi": "C = Cima Coppi",
    "profile_a11y": "Profil altimétrique : {{km}} km, altitude maximale {{max}} m, {{n}} ascensions principales",
    "profile_sprint": "S = sprint intermédiaire",
    "profile_tap_climb": "Touchez une montée pour le détail",
    "profile_sprint_bonus": "Sprint · bonus",
    "climb_base": "Base",
    "climb_summit": "Sommet",
    "climb_avg": "Pente moyenne",
    "climb_length": "Longueur",
    "profile_bonus": "B = point bonus"
  },
  "join": {
    "back_home": "Retour à l'accueil",
    "welcome": "Bienvenue dans la ligue !",
    "already_member": "Tu es déjà membre de cette ligue.",
    "error": "Impossible de rejoindre la ligue.",
    "joining": "Accès à la ligue...",
    "success": "Accès effectué !"
  },
  "leaderboard": {
    "stage_cancelled": "Étape {{n}} annulée : elle ne compte pas pour le classement",
    "loading": "Chargement...",
    "no_result_title": "Aucun résultat",
    "no_result_sub": "Les résultats de cette course ne sont pas encore disponibles.",
    "gc_rank": "Classement Général",
    "team_no_data": "Aucune donnée d'équipe pour cette étape.",
    "team_title": "CLASSEMENT ÉQUIPES",
    "stage": "Étape {{n}}",
    "general": "Général",
    "stage_rank": "Classement Étape {{n}}",
    "no_data_title": "Données non disponibles",
    "no_data_sub": "Le classement de cette étape n'a pas encore été calculé.",
    "one_day_race": "Course d'un jour",
    "title": "Classement",
    "no_data": "Aucune donnée disponible.",
    "share": "Partager",
    "jersey_tempo": "Temps",
    "jersey_punti": "Points",
    "jersey_gpm": "GPM",
    "tab_individual": "Individuel",
    "tab_team": "Équipe",
    "share_text": "{{name}}\n\n{{text}}\n\n{{site}}",
    "sharing": "...",
    "race_tag_live": "EN COURS",
    "race_tag_done": "TERMINÉE",
    "race_tag_soon": "BIENTÔT",
    "leader_label": "En tête",
    "lead_over_second": "{{gap}} sur le 2e",
    "winner": "Vainqueur",
    "sheet_total": "Total",
    "tie": "ex æquo",
    "top10_count": "{{count}} dans le top 10",
    "has_winner": "A le vainqueur",
    "my_rank": "Ta position",
    "counts_for_team": "Compte pour l'équipe",
    "not_counting": "Ne compte pas",
    "share_label": "CLASSEMENT",
    "gap_above": "{{gap}} du {{pos}}e",
    "gap_below": "{{gap}} sur le {{pos}}e",
    "trend_up": "Monte de {{n}} places",
    "trend_down": "Descendu de {{n}} places",
    "trend_same": "Position inchangée",
    "sheet_by_stage": "Étape par étape"
  },
  "leagues": {
    "albo": "Palmarès",
    "no_podio": "n'a pas encore obtenu de podium.",
    "victories": "Victoires",
    "second": "2ème place",
    "third": "3ème place",
    "races_count_one": "1 course",
    "races_count_many": "{{count}} courses",
    "races_count_other": "{{count}} courses",
    "player_a": "-- Joueur A --",
    "player_b": "-- Joueur B --",
    "draws_one": "1 match nul",
    "draws_many": "{{count}} matchs nuls",
    "draws_other": "{{count}} matchs nuls",
    "on_races_one": "sur 1 course",
    "on_races_many": "sur {{count}} courses",
    "on_races_other": "sur {{count}} courses",
    "no_common": "Aucune course en commun avec des résultats.",
    "settings": "PARAMÈTRES",
    "your_position": "Ta position",
    "stagionale": "Classement de la Saison",
    "hide": "MASQUER",
    "show_all_one": "TOUT AFFICHER (1 autre)",
    "show_all_many": "TOUT AFFICHER ({{count}} autres)",
    "show_all_other": "TOUT AFFICHER ({{count}} autres)",
    "no_data": "Aucune donnée disponible pour le moment.",
    "head2head": "Face à face",
    "races_count": "{{count}} courses",
    "draws": "{{count}} nuls",
    "on_races": "sur {{count}} courses",
    "show_all": "TOUT AFFICHER ({{count}} autres)",
    "badge_empty_1": "Aucun badge pour l'instant — la gloire t'attend ! 🚴",
    "badge_empty_2": "Zéro succès pour le moment, mais chaque course est une occasion. 💪",
    "badge_empty_3": "Toujours aucun badge — les grands champions partent de zéro. 🏅",
    "badge_empty_4": "Le premier badge est toujours le plus difficile. On y est presque ! ⚡",
    "gap_to_podium": "{{gap}} pts du podium",
    "gap_to_prev": "{{gap}} pts du {{pos}}e",
    "lead_over_next": "+{{gap}} pts sur le {{pos}}e",
    "invite_title": "Tu joues seul ?",
    "invite_body": "Invite tes amis à jouer ensemble dans cette ligue.",
    "invite_cta": "Inviter des amis",
    "pick_member": "Choisis un joueur",
    "position_a11y": "Position {{pos}}",
    "load_error": "Impossible de charger la ligue.",
    "tab_standings": "Classement",
    "tab_stats": "Statistiques",
    "tab_rivalry": "Défis"
  },
  "league": {
    "member_count_one": "1 utilisateur dans cette ligue",
    "member_count_many": "{{count}} utilisateurs dans cette ligue",
    "member_count_other": "{{count}} utilisateurs dans cette ligue",
    "index_join": "Rejoindre",
    "index_create": "Créer une ligue",
    "manage_title": "Gestion {{name}}",
    "err_name": "Saisis un nom",
    "err_password": "Saisis un mot de passe",
    "err_creation": "Erreur lors de la création",
    "create_title": "Créer une nouvelle ligue",
    "create": "Créer la ligue",
    "privacy": "Confidentialité",
    "public": "Publique",
    "private": "Privée",
    "err_join": "Erreur ou tu es déjà inscrit",
    "join_title": "Rejoindre une ligue",
    "search_placeholder": "Rechercher par nom...",
    "search": "Rechercher",
    "no_leagues_found": "Aucune ligue trouvée",
    "join_btn": "Rejoindre",
    "password_insert": "Saisis le mot de passe :",
    "calendar_section": "Calendrier",
    "calendar_desc_admin": "Gère les courses de la ligue",
    "calendar_desc_user": "Courses au calendrier",
    "manage": "Gérer",
    "view": "Afficher",
    "calendar_title": "Calendrier de la ligue",
    "calendar_save_one": "Enregistrer le calendrier (1 course)",
    "calendar_save_many": "Enregistrer le calendrier ({{count}} courses)",
    "calendar_save_other": "Enregistrer le calendrier ({{count}} courses)",
    "races_selected_one": "1 course sélectionnée",
    "races_selected_many": "{{count}} courses sélectionnées",
    "races_selected_other": "{{count}} courses sélectionnées",
    "deselect_all": "Tout désélectionner",
    "select_all": "Tout sélectionner",
    "loading": "Chargement...",
    "settings_section": "Paramètres de la ligue",
    "settings_name": "Nom de la ligue",
    "settings_save": "Enregistrer",
    "settings_autopick": "Pronostic automatique",
    "settings_autopick_desc": "Si un utilisateur ne fait pas son pronostic, le système choisit le meilleur coureur disponible lors de l'étape précédente.",
    "settings_team_race": "Course par équipes",
    "settings_team_race_desc": "Active le mode équipe pour cette ligue.",
    "settings_team_size": "Nombre max de membres par équipe",
    "settings_scoring": "Calcul des points",
    "settings_scoring_best2": "Meilleurs 2 — somme des deux premiers",
    "settings_scoring_avg": "Moyenne de tous les membres",
    "settings_flip": "Flip",
    "settings_flip_desc": "Chaque utilisateur peut indiquer un coureur joker pour une étape de son choix. Le meilleur entre le titulaire et le flip sera automatiquement choisi lors du calcul des points. Utilisable une seule fois par course.",
    "invite_section": "Lien d'invitation",
    "invite_loading": "Chargement...",
    "invite_copied": "Copié !",
    "invite_copy": "Copier",
    "invite_share_btn": "Partager",
    "members_section": "Membres",
    "members_title_admin": "Gestion des membres",
    "members_title_user": "Membres de la ligue",
    "leaving": "Sortie...",
    "leave": "Quitter cette ligue",
    "admin_badge": "Admin",
    "remove": "Retirer",
    "pick_admin_title": "Correction des pronostics",
    "pick_admin_desc": "Modifie les pronostics des utilisateurs",
    "pick_admin_open": "Ouvrir",
    "pick_admin_save": "Enregistrer les pronostics",
    "pick_admin_none": "— aucun —",
    "pick_admin_search": "Chercher un coureur ou un dossard",
    "pick_admin_retired": "abandon",
    "pick_admin_saved2": "{{set}} picks enregistrés, {{removed}} supprimés",
    "pick_admin_nochange": "Aucune modification à enregistrer",
    "pick_admin_undo": "Annuler la dernière correction",
    "pick_admin_undone": "Correction annulée",
    "pick_admin_future": "{{n}} picks d'étapes futures avec le même coureur ont aussi été supprimés",
    "pick_admin_notify": "Prévenir les joueurs",
    "pick_admin_no_calendar": "Cette course n'est pas dans le calendrier de la ligue : impossible d'enregistrer",
    "stats_section": "Statistiques",
    "stats_participation": "Participation par étape",
    "stats_title": "Statistiques de participation",
    "stats_no_data": "Aucune donnée disponible.",
    "stats_error": "Impossible de charger les statistiques. Réessaie.",
    "team_loading": "Chargement de l'équipe...",
    "team_section": "Équipe",
    "team_cancel": "Annuler",
    "team_create_btn": "+ Créer une équipe",
    "team_locked": "Course en cours — modifications d'équipe désactivées",
    "team_create": "Créer l'équipe",
    "team_members_count_one": "1/{{max}} membre",
    "team_members_count_many": "{{count}}/{{max}} membres",
    "team_members_count_other": "{{count}}/{{max}} membres",
    "team_invite_btn": "+ Inviter",
    "team_leave": "Sortir",
    "team_save": "Enregistrer",
    "team_pwd_hint": "Laisse vide pour rendre publique",
    "team_pending": "En attente de réponse",
    "team_invite_cancel": "Annuler",
    "team_invite_section": "Inviter un membre",
    "team_no_invitable": "Aucun membre disponible à inviter.",
    "team_invite_action": "Inviter",
    "team_private_label": "\"{{name}}\" est privée :",
    "team_join_action": "Entrer",
    "team_empty": "Aucune équipe pour le moment — sois le premier à en créer une !",
    "team_mine": "LA TIENNE",
    "team_join": "Rejoindre",
    "team_full": "Complète",
    "team_members": "Membres",
    "join": "Rejoindre",
    "calendar_save": "Enregistrer le calendrier ({{count}} courses)",
    "invite_share": "Partager",
    "races_selected": "{{count}} courses sélectionnées",
    "invite_desc": "Partage ce lien — celui qui clique rejoint directement la ligue.",
    "invite_desc_pwd": "Partage ce lien — celui qui clique rejoint directement la ligue avec le mot de passe déjà inclus.",
    "member_count": "{{count}} utilisateurs dans cette ligue",
    "team_members_count": "{{count}}/{{max}} membres",
    "create_name_placeholder": "Ex : Les Amis du Pédalier",
    "create_password_placeholder": "Mot de passe d'accès",
    "calendar_saved": "Calendrier enregistré !",
    "err_name_empty": "Le nom ne peut pas être vide",
    "settings_saved": "Paramètres enregistrés !",
    "pwd_public_placeholder": "Laisse vide pour une ligue publique",
    "invite_share_title": "Rejoins {{name}} sur Virtua Cycling",
    "invite_share_message": "Rejoins la ligue \"{{name}}\" sur Virtua Cycling !\n{{url}}",
    "invite_regen_confirm": "Régénérer le lien ? Tous les liens précédents cesseront de fonctionner.",
    "invite_regenerating": "Régénération...",
    "invite_regen_btn": "Régénérer le lien (révoque les précédents)",
    "confirm_remove": "Retirer {{name}} de la ligue ?",
    "member_removed": "{{name}} retiré",
    "confirm_demote": "Veux-tu retirer les privilèges admin à {{name}} ?",
    "confirm_promote": "Veux-tu promouvoir {{name}} admin ?",
    "demote_admin": "Retirer Admin",
    "promote_admin": "Admin",
    "pick_admin_saved": "{{count}} pronostics enregistrés !",
    "confirm_team_leave": "Quitter l'équipe ?",
    "confirm_kick": "Retirer {{name}} de l'équipe ?",
    "team_invite_sent": "Invitation envoyée !",
    "team_pwd_saved": "Mot de passe mis à jour !",
    "team_name_placeholder": "Nom de l'équipe...",
    "team_rename_placeholder": "Nouveau nom...",
    "team_newpwd_placeholder": "Nouveau mot de passe..."
  },
  "profile": {
    "nick_title": "Pseudo",
    "theme_title": "Personnalisation du thème",
    "theme_dark": "Sombre",
    "theme_light": "Clair",
    "lang": "Langue",
    "save_lang": "Enregistrer la langue",
    "nick_success": "Pseudo mis à jour !",
    "nick": "Pseudo",
    "nick_placeholder": "Saisis un pseudo",
    "update_btn": "Mettre à jour",
    "pass": "Mot de passe",
    "show_pass": "Afficher le mot de passe",
    "update_pass": "Mettre à jour le mot de passe",
    "avatars_title": "Avatars",
    "avatars": "Afficher les avatars",
    "avatars_sub": "Désactive-le si ton téléphone est lent : à la place des avatars tu verras le maillot des coureurs et le nom des joueurs. Ton avatar sur l'accueil reste.",
    "notif_title": "Notifications Push",
    "my_leagues": "Mes ligues",
    "members_count_one": "1 membre",
    "members_count_many": "{{count}} membres",
    "members_count_other": "{{count}} membres",
    "default_badge": "PAR DÉFAUT",
    "set_default": "Définir par défaut",
    "leave": "Quitter",
    "settings": "Paramètres du profil",
    "hi": "Salut",
    "intro": "ici tu peux gérer ton compte.",
    "admin_panel": "Panneau d'administration",
    "theme_sub": "Synchronisé sur tous tes appareils.",
    "lang_title": "Langue / Language",
    "security_title": "Accès et Sécurité",
    "security_success": "Données mises à jour !",
    "notif_enabled": "Activer les notifications",
    "notif_enabled_sub": "Active ou désactive toutes les notifications",
    "notif_results": "Résultats de course",
    "notif_results_sub": "Notification à la publication des résultats",
    "notif_startlist": "Liste de départ",
    "notif_startlist_sub": "Notification dès que la liste de départ est disponible",
    "notif_reminder": "Rappel pronostic",
    "notif_reminder_sub": "Reçois un rappel avant la clôture des pronostics",
    "notif_reminder_off": "Aucun rappel",
    "notif_reminder_no_pick": "Seulement si je n'ai pas encore choisi",
    "notif_reminder_always": "Toujours",
    "notif_saving": "Enregistrement...",
    "notif_saved": "Préférences enregistrées !",
    "notif_error": "Erreur lors de l'enregistrement",
    "nick_taken": "Pseudo déjà utilisé",
    "pass_min_length": "Le mot de passe doit contenir au moins 6 caractères",
    "pass_mismatch": "Les mots de passe ne correspondent pas",
    "new_pass_placeholder": "Nouveau mot de passe",
    "league_default_updated": "Ligue par défaut mise à jour !",
    "league_leave_confirm": "Es-tu sûr de vouloir quitter \"{{name}}\" ?",
    "league_left": "Ligue quittée.",
    "confirm_password": "Confirme le mot de passe",
    "avatar_title": "Ton avatar",
    "avatar_jersey": "Maillot",
    "avatar_cap": "Casquette",
    "avatar_glasses": "Lunettes",
    "avatar_cyclist": "Cycliste",
    "avatar_patch": "Écusson du maillot",
    "avatar_saved": "Avatar enregistré !",
    "avatar_save_btn": "Enregistrer l'avatar",
    "rules": "Règlement",
    "report_bug": "Signaler un problème",
    "bug_sent": "Signalement envoyé, merci !",
    "bug_placeholder": "Décris le problème...",
    "group_identity": "Identité",
    "group_account": "Compte",
    "group_contact": "Contactez-nous",
    "group_danger": "Zone dangereuse",
    "change_pass": "Modifier",
    "cancel": "Annuler",
    "show_more": "Tout afficher ({{count}} de plus)",
    "show_less": "Afficher moins",
    "delete_confirm": "Es-tu sûr de vouloir supprimer ton compte ? Cette action est irréversible et toutes tes données seront définitivement supprimées.",
    "delete_desc": "La suppression est définitive et efface toutes tes données, sélections, ligues et préférences.",
    "delete_btn": "Supprimer mon compte",
    "delete_league_owner": "Tu as créé une ligue avec d'autres membres : supprimer ton compte la ferait disparaître pour tous. Contacte-nous pour la transférer ou supprime-la d'abord.",
    "replay_tour": "Revoir le tour",
    "leave_feedback": "Laisser un avis",
    "feedback_placeholder": "Une idée, une suggestion ou un commentaire : nous serons ravis de te lire...",
    "feedback_sent": "Merci pour ton avis ! 🙏",
    "rate_app": "Noter Virtua Cycling ⭐"
  },
  "login": {
    "err_nickname": "Saisis un pseudo",
    "err_nickname_taken": "Pseudo déjà utilisé",
    "register_ok": "Registration completed! Check your email and confirm your account before logging in.",
    "err_email": "Saisis ton email",
    "forgot_sent": "Email envoyé ! Vérifie ta boîte de réception.",
    "tagline": "Prends ta place dans la voiture balai.",
    "tab_login": "Se connecter",
    "tab_register": "S'inscrire",
    "forgot_hint": "Saisis ton email et nous t'enverrons un lien pour réinitialiser ton mot de passe.",
    "email": "Email",
    "forgot_send": "Envoyer le lien",
    "back": "← Retour à la connexion",
    "nickname": "Pseudo",
    "password": "Mot de passe",
    "btn_login": "SE CONNECTER",
    "btn_register": "S'INSCRIRE",
    "forgot_pass": "Mot de passe oublié ?",
    "or": "ou",
    "google_login": "Se connecter avec Google",
    "google_register": "S'inscrire avec Google",
    "privacy_text": "En continuant, tu acceptes notre",
    "privacy_link": "Politique de confidentialité",
    "loading": "…"
  },
  "news": {
    "title": "ACTUALITÉS",
    "loading": "Chargement...",
    "no_news": "Aucune actualité disponible.",
    "pinned": "À la une",
    "not_found": "Article introuvable.",
    "open_external": "Ouvrir l'article sur {{source}}",
    "disclaimer": "Titres et liens proviennent de sources externes : les articles appartiennent à leurs éditeurs.",
    "tab_unread_one": "{{count}} nouvelle actualité",
    "tab_unread_other": "{{count}} nouvelles actualités",
    "load_error": "Impossible de charger les actualités."
  },
  "reset_password": {
    "title": "NOUVEAU MOT DE PASSE",
    "subtitle": "Choisis un nouveau mot de passe pour ton compte",
    "show_pass": "Afficher le mot de passe",
    "loading": "Vérification du lien en cours...",
    "success": "Mot de passe mis à jour ! Tu vas être redirigé..."
  },
  "confirm": {
    "verifying": "Vérification en cours...",
    "error": "Erreur lors de la confirmation.",
    "success": "Email confirmé ! Tu vas être redirigé...",
    "missing_params": "Paramètres manquants dans le lien.",
    "missing_params_detail": "Assure-toi d'avoir cliqué sur le bon lien depuis ton email.",
    "critical_error": "Erreur critique de connexion."
  },
  "notifications": {
    "title": "Notifications",
    "empty": "Aucune notification pour le moment",
    "accept": "Accepter",
    "refuse": "Refuser",
    "now": "À l'instant",
    "minutes_ago": "il y a {{count}} min",
    "hours_ago": "il y a {{count}}h"
  },
  "quiz": {
    "card_sub": "10 questions sur le Tour de France — combien en sais-tu ?",
    "loading": "Chargement des questions...",
    "no_questions": "Aucune question disponible",
    "question_count": "Question {{current}} sur {{total}}",
    "easy": "Facile",
    "medium": "Moyen",
    "hard": "Difficile",
    "correct": "Bonne réponse !",
    "wrong": "Faux. La réponse était : {{answer}}",
    "next": "Suivante",
    "see_result": "Voir le résultat",
    "restart": "Rejouer",
    "result_excellent": "Tu es un véritable expert du cyclisme !",
    "result_good": "Excellente connaissance du Tour de France !",
    "result_average": "Connaissance correcte. Regarde plus de courses !",
    "result_poor": "Il y a une marge de progression — mais c'est pour ça qu'on pédale !"
  },
  "person": {
    "hint": "Choisis l'apparence de ton avatar : tu le verras sur l'accueil.",
    "gender": "Genre",
    "man": "Homme",
    "woman": "Femme",
    "hair_short": "Courts",
    "hair_curly": "Bouclés",
    "hair_wavy": "Ondulés",
    "hair_shaved": "Rasé",
    "hair_pixie": "Pixie",
    "hair_bob": "Carré",
    "headwear": "Couvre-chef",
    "wear_none": "Aucun",
    "wear_cap": "Casquette",
    "wear_helmet": "Casque",
    "glasses": "Lunettes",
    "glasses_off": "Non",
    "glasses_on": "Oui",
    "jersey": "Maillot",
    "jersey_vertical": "Verticale",
    "jersey_horizontal": "Horizontale",
    "jersey_classic": "Classique",
    "jersey_diagonal": "Diagonale",
    "jersey_dots": "Pois",
    "row_skin": "Peau",
    "row_hair": "Cheveux",
    "row_brow": "Sourcils",
    "row_iris": "Yeux",
    "row_wear": "Couvre-chef",
    "row_visor": "Visière",
    "row_vents": "Aérations",
    "row_frame": "Monture des lunettes",
    "save": "ENREGISTRER",
    "saved": "Avatar enregistré",
    "save_error": "Erreur d'enregistrement",
    "reset": "Réinitialiser",
    "reset_done": "Réinitialisé",
    "tab_face": "Visage",
    "tab_hair": "Cheveux",
    "tab_gear": "Accessoires",
    "tab_jersey": "Maillot",
    "row_lens": "Verres",
    "jersey_body": "Corps",
    "jersey_sleeves": "Manches",
    "jersey_band": "Bande",
    "jersey_trim": "Col et poignets",
    "view_mine": "Mon avatar",
    "view_world_champion": "Maillot arc-en-ciel",
    "world_champion_since": "Champion du monde dans {{league}} depuis le {{date}}",
    "view_european_champion": "Maillot européen",
    "european_champion_since": "Champion d'Europe dans {{league}} depuis le {{date}}",
    "view_worldcup_leader": "Maillot de la Coupe du monde",
    "worldcup_leader_since": "Leader du classement de {{league}} depuis le {{date}}",
    "kits_show": "Show team kits (admin)",
    "kits_hide": "Hide team kits",
    "kits_hint": "Team jerseys imported from PCS: check colours and design. Kits are fixed in the database.",
    "kits_approx": "approximate",
    "kits_men": "Men",
    "kits_women": "Women",
    "kits_wt": "WorldTeam",
    "kits_pro": "ProTeam",
    "kits_tap": "tap a team to see its riders",
    "kits_no_riders": "No avatars for this team yet.",
    "avatar_edit": "Modifier l'avatar",
    "avatar_cut": "Coupe",
    "avatar_hair": "Cheveux",
    "avatar_skin": "Peau",
    "avatar_beard": "Barbe",
    "avatar_beard_none": "Aucune",
    "avatar_face": "Visage",
    "avatar_face_none": "Standard",
    "avatar_face_a": "Mince",
    "avatar_face_b": "Robuste",
    "avatar_face_c": "Jeune",
    "avatar_face_d": "Anguleux",
    "avatar_face_e": "Mûr",
    "avatar_face_f": "Souriant",
    "avatar_face_g": "Sourire fermé",
    "avatar_brow": "Sourcils",
    "avatar_brow_0": "Normaux",
    "avatar_brow_1": "Fins",
    "avatar_brow_2": "Épais",
    "avatar_beard_light": "Légère",
    "avatar_hex": "Autre couleur (#RRGGBB)",
    "avatar_save": "Enregistrer",
    "avatar_reset": "Réinitialiser",
    "avatar_undo": "Annuler la dernière modification",
    "avatar_saved": "Enregistré",
    "avatar_bad_hex": "Couleur invalide : utilise #RRGGBB",
    "avatar_err": "Échec de l'enregistrement",
    "avatar_beard_legend": "1 ombre · 2 moustache · 3 courte · 4 pleine · 6 moustache+bouc · 7 cercle · 8 barbe naissante",
    "hair_wavy_medium": "Ondulés mi-longs",
    "hair_receding": "Dégarni",
    "hair_messy": "Ébouriffé",
    "hair_buzz": "Très court",
    "hair_curly_short": "Boucles courtes",
    "hair_medium": "Mi-longs",
    "hair_flip_off": "Côté normal",
    "hair_flip_on": "Inversé",
    "hair_side_part": "Raie sur le côté",
    "hair_slicked_back": "En arrière",
    "hair_forward": "Vers l'avant",
    "hair_high_line": "Front dégarni",
    "hair_wavy_short": "Ondulés courts",
    "hair_curly_medium": "Boucles moyennes",
    "hair_receding_short": "Dégarni court",
    "beard_stubble_light": "Barbe naissante",
    "hair_long": "Longs",
    "hair_ponytail": "Queue de cheval",
    "hair_bun": "Chignon",
    "hair_long_wavy": "Ondulés",
    "hair_braid": "Tresse",
    "beard": "Barbe",
    "beard_none": "Aucune",
    "beard_stubble": "Ombre",
    "beard_moustache": "Moustache",
    "beard_short": "Courte",
    "beard_full": "Pleine",
    "beard_goatee": "Moustache et bouc",
    "beard_circle": "En cercle",
    "beard_op_normal": "Normale",
    "beard_op_light": "Légère",
    "fringe": "Frange",
    "fringe_off": "Sans",
    "fringe_on": "Avec frange"
  },
  "app_update": {
    "title": "Nouvelle version prête",
    "body": "Redémarre l'app pour profiter des nouveautés.",
    "restart": "Redémarrer",
    "later": "Plus tard"
  },
  "avatar": {
    "invite_title": "Voici ton avatar !",
    "invite_body": "On en a créé un pour toi : personnalise-le comme tu veux.",
    "invite_cta": "Personnaliser",
    "invite_dismiss": "Fermer",
    "edit_a11y": "Personnalise ton avatar"
  },
  "jersey_celebration": {
    "ok": "Génial !"
  },
  "insight": {
    "you": "Avec toi",
    "form": "Forme",
    "never": "Jamais choisi par toi : ce serait la première fois.",
    "picked": "Fois choisi",
    "avg_rank": "Place moyenne",
    "avg_gap": "Écart moyen",
    "best": "Meilleur résultat",
    "dnf": "Abandons avec toi",
    "last": "Dernière fois",
    "retired": "abandon",
    "form_avg": "Moyenne des 5 dernières",
    "season_races": "Courses cette saison",
    "top10": "Top 10",
    "wins": "Victoires",
    "dnfs": "Abandons",
    "cat_1": "Étapes de plat",
    "cat_2": "Étapes de montagne",
    "cat_3": "Étapes vallonnées",
    "last5": "5 derniers résultats",
    "no_results": "Pas encore de résultat cette saison.",
    "open_a11y": "Statistiques de {{name}}",
    "summary": "{{n}}× avec toi · moy. {{rank}}e",
    "summary_never": "Jamais choisi par toi",
    "open": "Insights"
  },
  "badges": {
    "title": "Badges",
    "album_title": "Palmarès",
    "earned_of": "{{earned}} sur {{total}} badges",
    "open_album": "Ouvrir le palmarès",
    "recent": "Derniers obtenus",
    "next_goals": "Objectifs à portée",
    "filter_all": "Tous",
    "filter_earned": "Obtenus",
    "filter_todo": "À obtenir",
    "group_gt": "Grands Tours",
    "group_monuments": "Monuments et classiques",
    "group_picks": "Talent aux choix",
    "group_consistency": "Constance",
    "group_league": "Classement de ligue",
    "group_social": "Social",
    "group_meta": "Collection",
    "tier_1": "Bronze",
    "tier_2": "Argent",
    "tier_3": "Or",
    "tier_4": "Platine",
    "tier_special": "Étape clé",
    "secret_title": "Badge secret",
    "secret_hint": "Découvre-le en jouant.",
    "earned_on": "Obtenu le {{date}}",
    "progress": "{{value}} sur {{threshold}}",
    "rarity": "{{pct}} % de la ligue l'ont ({{n}} sur {{m}})",
    "rarity_none": "Personne ne l'a encore : tu peux être le premier.",
    "seasons": "Saisons obtenues : {{count}}",
    "complete": "Terminé",
    "locked": "À obtenir",
    "player": "Joueur",
    "none_me": "Pas encore de badge : la prochaine course est ta chance.",
    "none_other": "{{name}} n'a pas encore de badge.",
    "empty_filter": "Rien à afficher avec ce filtre.",
    "load_error": "Impossible de charger les badges.",
    "not_enabled": "Les badges ne sont pas encore actifs pour cette ligue.",
    "fam": {
      "RE_GT": {
        "title": "Roi des Grands Tours",
        "desc": "Grands Tours remportés : {{n}}"
      },
      "WIN_GIRO": {
        "title": "Roi du Giro",
        "desc": "Remporte le classement général du Giro d'Italia"
      },
      "WIN_TOUR": {
        "title": "Roi du Tour",
        "desc": "Remporte le classement général du Tour de France"
      },
      "WIN_VUELTA": {
        "title": "Roi de la Vuelta",
        "desc": "Remporte le classement général de la Vuelta"
      },
      "GT_PODI": {
        "title": "Podiums dans les Grands Tours",
        "desc": "Podiums dans les Grands Tours : {{n}}"
      },
      "GT_DAYS": {
        "title": "Jours en tête",
        "desc": "Jours de leader du classement général : {{n}}"
      },
      "FIRST_PINK": {
        "title": "Maglia rosa",
        "desc": "Deviens leader du classement général du Giro d'Italia"
      },
      "FIRST_YELLOW": {
        "title": "Maillot jaune",
        "desc": "Deviens leader du classement général du Tour de France"
      },
      "FIRST_RED": {
        "title": "Maillot rouge",
        "desc": "Deviens leader du classement général de la Vuelta"
      },
      "GT_GREEN": {
        "title": "Roi des sprinteurs",
        "desc": "Classements par points remportés dans les Grands Tours : {{n}}"
      },
      "GT_POIS": {
        "title": "Roi de la montagne",
        "desc": "Classements de la montagne remportés dans les Grands Tours : {{n}}"
      },
      "GT_STAGE_WINS": {
        "title": "Chasseur d'étapes",
        "desc": "Étapes remportées dans les Grands Tours : {{n}}"
      },
      "GT_WIRE": {
        "title": "De bout en bout",
        "desc": "Mène le général de la première à la dernière étape et remporte le Grand Tour"
      },
      "GT_COMEBACK": {
        "title": "Remontada",
        "desc": "Remporte un Grand Tour en étant hors du top 10 après la première semaine"
      },
      "GT_TRIPLE_JERSEY": {
        "title": "Triomphe total",
        "desc": "Remporte général, points et montagne dans le même Grand Tour"
      },
      "GT_HEARTBREAK": {
        "title": "La déconvenue",
        "desc": "Tu étais leader à la veille de la dernière étape, mais tu n'as pas gagné le Grand Tour"
      },
      "TRIPLE_CROWN": {
        "title": "Triple Couronne",
        "desc": "Remporte le Giro, le Tour et la Vuelta"
      },
      "THE_DOUBLE": {
        "title": "Le Doublé",
        "desc": "Remporte le Giro et le Tour la même année"
      },
      "RE_MONUMENTI": {
        "title": "Roi des Monuments",
        "desc": "Monuments remportés : {{n}}"
      },
      "WIN_SANREMO": {
        "title": "La Classicissima",
        "desc": "Remporte Milan-San Remo"
      },
      "WIN_FIANDRE": {
        "title": "Le Tour des Flandres",
        "desc": "Remporte le Tour des Flandres"
      },
      "WIN_ROUBAIX": {
        "title": "L'Enfer du Nord",
        "desc": "Remporte Paris-Roubaix"
      },
      "WIN_LIEGI": {
        "title": "La Doyenne",
        "desc": "Remporte Liège-Bastogne-Liège"
      },
      "WIN_LOMBARDIA": {
        "title": "La classique des feuilles mortes",
        "desc": "Remporte le Tour de Lombardie"
      },
      "MONUMENTS_SWEEP": {
        "title": "Grand Chelem des Monuments",
        "desc": "Remporte les 5 Monuments"
      },
      "RE_DEL_NORD": {
        "title": "Roi du Nord",
        "desc": "Remporte les Flandres et Roubaix la même année"
      },
      "ARDENNES": {
        "title": "Triplé des Ardennes",
        "desc": "Remporte l'Amstel, la Flèche Wallonne et Liège la même année"
      },
      "DUE_MARI": {
        "title": "Course des deux mers",
        "desc": "Remporte Paris-Nice et Tirreno-Adriatico la même année"
      },
      "MODALITA_POGACAR": {
        "title": "Mode Pogačar",
        "desc": "Remporte les 3 Grands Tours et les 5 Monuments"
      },
      "RE_CLASSICHE": {
        "title": "Roi des Classiques",
        "desc": "Classiques remportées : {{n}}"
      },
      "RE_TAPPE": {
        "title": "Roi des courses par étapes",
        "desc": "Courses par étapes remportées : {{n}}"
      },
      "WORLD_CHAMP": {
        "title": "Champion du monde",
        "desc": "Remporte la course en ligne des Championnats du monde"
      },
      "EURO_CHAMP": {
        "title": "Champion d'Europe",
        "desc": "Remporte la course en ligne des Championnats d'Europe"
      },
      "CRONOMAN": {
        "title": "Rouleur du chrono",
        "desc": "Remporte un contre-la-montre des Championnats du monde ou d'Europe"
      },
      "SOLO_WIN": {
        "title": "Solo Win",
        "desc": "Seul dans la ligue à choisir le vainqueur : {{n}}"
      },
      "PROFETA": {
        "title": "Prophète",
        "desc": "Choix gagnants : {{n}}"
      },
      "FIUTO": {
        "title": "Flair",
        "desc": "Vainqueurs choisis par peu de joueurs : {{n}}"
      },
      "LEAGUE_WINS": {
        "title": "Vainqueur de course",
        "desc": "Courses remportées dans la ligue : {{n}}"
      },
      "LEAGUE_PODI": {
        "title": "Habitué du podium",
        "desc": "Podiums de course dans la ligue : {{n}}"
      },
      "DEBUTTO": {
        "title": "Débuts",
        "desc": "Joue ta première course"
      },
      "PRESENZE": {
        "title": "Présences",
        "desc": "Courses jouées : {{n}}"
      },
      "SERIE": {
        "title": "En série",
        "desc": "Courses consécutives jouées : {{n}}"
      },
      "STAGIONE_PERFETTA": {
        "title": "Saison parfaite",
        "desc": "Joue toutes les courses de la saison"
      },
      "LEADER_STAGIONE": {
        "title": "Aux commandes",
        "desc": "Courses terminées en tête du classement : {{n}}"
      },
      "CAMPIONE_LEGA": {
        "title": "Champion de ligue",
        "desc": "Termine la saison à la première place du classement"
      },
      "PODIO_LEGA": {
        "title": "Podium de ligue",
        "desc": "Termine la saison sur le podium du classement"
      },
      "TOP10_LEGA": {
        "title": "Top 10",
        "desc": "Termine la saison dans les 10 premiers du classement"
      },
      "SCALATORE": {
        "title": "Grimpeur",
        "desc": "Places gagnées sur une seule course : {{n}}"
      },
      "AMMAZZAGIANTI": {
        "title": "Tueur de géants",
        "desc": "Courses terminées devant le leader du classement : {{n}}"
      },
      "ALBUM": {
        "title": "Album",
        "desc": "Badges obtenus : {{n}}"
      },
      "LEGGENDA": {
        "title": "Légende",
        "desc": "Obtiens tous les badges"
      }
    },
    "celebration_one": "Nouveau badge !",
    "celebration_many": "{{n}} nouveaux badges !",
    "celebration_more": "et {{n}} de plus",
    "share": "Partager",
    "share_label": "BADGE OBTENU",
    "share_dialog": "Mon badge : {{name}}",
    "share_text": "J'ai obtenu le badge « {{name}} » sur Virtua Cycling ! {{site}}",
    "showcase_title": "À la une",
    "showcase_hint": "Choisis jusqu'à 3 badges à mettre en avant. Sans choix, on affiche les plus rares que tu as.",
    "showcase_edit": "Modifier",
    "showcase_auto": "Automatique",
    "showcase_save": "Enregistrer",
    "showcase_count": "{{n}} sur 3 choisis",
    "showcase_err": "Impossible d'enregistrer la sélection.",
    "showcase_a11y": "Tes badges en vedette",
    "showcase_none": "Obtiens ton premier badge pour le voir ici.",
    "showcase_pick_empty": "Tu n'as pas encore de badge à mettre en vitrine.",
    "jerseys_title": "Maillots des Grands Tours",
    "jersey_pink": "Maglia rosa",
    "jersey_yellow": "Maillot jaune",
    "jersey_red": "Maillot rouge",
    "days_caption": "Jours en maillot",
    "section_jerseys": "Maillots",
    "special_title": "Maillots spéciaux",
    "special_now": "Porté actuellement",
    "trophy_sub": "Badges, maillots et palmarès"
  },
  "rivalry": {
    "title": "Défis",
    "intro": "Choisis un adversaire. S'il accepte, à partir de cette course, celui qui termine devant l'autre marque le point. Toute la ligue voit où ça en est.",
    "slots": "Défis lancés : {{used}} sur {{max}}",
    "limit_reached": "Tu as lancé le maximum de défis. Annule ou termine-en un pour en lancer un autre.",
    "no_candidates": "Il n'y a pas d'autre joueur à défier.",
    "challenge_cta": "Lancer un défi",
    "pick_title": "Qui veux-tu défier ?",
    "confirm_challenge": "Défier {{name}} ? Il recevra la demande et pourra accepter ou refuser.",
    "sent": "Demande envoyée à {{name}}.",
    "accepted": "Tu as accepté le défi avec {{name}}.",
    "incoming_title": "Demandes reçues",
    "incoming_line": "{{name}} te défie",
    "accept": "Accepter",
    "decline": "Refuser",
    "waiting_title": "En attente de réponse",
    "waiting_line": "En attente de {{name}}",
    "cancel": "Annuler",
    "mine_title": "Tes défis",
    "league_title": "Dans la ligue",
    "ended_title": "Défis terminés : {{count}}",
    "empty": "Aucun défi en cours dans la ligue. Lance le premier !",
    "vs": "contre",
    "score_a11y": "{{a}} à {{b}}",
    "last_point": "Dernier point : {{name}} sur {{race}}",
    "no_races": "Aucune course pour l'instant",
    "won_by": "Remporté par {{name}}",
    "drawn": "Terminé sur un match nul",
    "detail_title": "Défi",
    "results_title": "Course par course",
    "no_results": "Aucun point attribué pour l'instant.",
    "point_to": "Point pour {{name}}",
    "end_cta": "Terminer le défi",
    "end_confirm": "Terminer le défi avec {{name}} ?",
    "rematch": "Revanche",
    "load_error": "Impossible de charger les défis.",
    "err_limit": "Tu as déjà lancé le maximum de défis.",
    "err_exists": "Vous êtes déjà en défi, ou une demande est en cours.",
    "err_invalid": "Cette demande n'est plus valide.",
    "err_generic": "L'action n'a pas pu être effectuée.",
    "notif_accepted": "Défi accepté",
    "notif_declined": "Défi refusé"
  },
  "competition": {
    "men": "Men Elite",
    "women": "Women Elite",
    "aria": "Compétition"
  },
  "no_league": {
    "title": "Vous ne participez à aucune ligue {{comp}}",
    "body": "Vous pouvez rejoindre une ligue ou en créer une nouvelle depuis la section Ligues.",
    "body_official": "Vous pouvez rejoindre la ligue officielle quand vous voulez, ou rejoindre ou créer une ligue privée depuis la section Ligues.",
    "join": "Rejoindre {{name}}",
    "go_leagues": "Aller aux ligues"
  }
}
